"use client"

import { useCallback, useState } from "react"

export function useGachaReveal() {
  const [revealOpen, setRevealOpen] = useState(false)
  const [revealPlayId, setRevealPlayId] = useState(0)
  const [resultOpen, setResultOpen] = useState(false)
  const [resultFadeIn, setResultFadeIn] = useState(false)

  const beginReveal = useCallback(() => {
    setResultOpen(false)
    setResultFadeIn(false)
    setRevealPlayId((id) => id + 1)
    setRevealOpen(true)
  }, [])

  const showResults = useCallback((fadeIn = true) => {
    setResultOpen(true)
    setResultFadeIn(fadeIn)
  }, [])

  const finishReveal = useCallback(() => {
    setRevealOpen(false)
    setResultFadeIn(false)
  }, [])

  const closeResults = useCallback(() => {
    setResultOpen(false)
    setResultFadeIn(false)
  }, [])

  return {
    revealOpen,
    revealPlayId,
    resultOpen,
    resultFadeIn,
    beginReveal,
    showResults,
    finishReveal,
    closeResults,
  }
}
